// extracted by mini-css-extract-plugin
export default {"settingsSection":"style--settingsSection--389d8d","header":"style--header--a780f2","description":"style--description--a67096"};